<h2>{{ title }}</h2>
<div>
  @for (product of suggestedProducts | async; track product.id) {
    <app-product-card [product]="product"></app-product-card>
  }
</div>
